import { RequiredFieldsState } from '../models/state.model';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: RequiredFieldsState = {};

const RequiredFieldsSlice = createSlice({
  name: 'requiredFields',
  initialState,
  reducers: {
    registerFieldSchema(state, action: PayloadAction<{ fieldName: string; value: boolean }>) {
      const { fieldName, value } = action.payload;
      state[fieldName] = value;
    },
    deleteFieldSchema(state, action: PayloadAction<string>) {
      delete state[action.payload];
    },
    clearValidationSchema() {
      return initialState;
    },
  },
});

export const { registerFieldSchema, deleteFieldSchema, clearValidationSchema } =
  RequiredFieldsSlice.actions;

const RequiredFieldsReducer = RequiredFieldsSlice.reducer;

export default RequiredFieldsReducer;